export default __webpack_public_path__ + "static/media/a-full-day.cfd4c1d0.jpg";